import { useMemo } from 'react';
import { roundMoneyAmount } from '../../utils/moneyAmount';

export interface UseSplitPaymentValidationArgs {
  total: number;
  amounts: Array<number | undefined>;
}

export interface SplitPaymentValidationResult {
  sum: number;
  remaining: number;
  isValid: boolean;
}

const TOLERANCE = 0.01;

export const computeSplitPaymentValidation = ({
  total,
  amounts,
}: UseSplitPaymentValidationArgs): SplitPaymentValidationResult => {
  const hasAllAmounts = amounts.every((amount) => amount !== undefined && amount > 0);
  const roundedAmounts = amounts.map((amount) => roundMoneyAmount(amount ?? 0));
  const sum = roundMoneyAmount(roundedAmounts.reduce((acc, amount) => acc + amount, 0));
  const roundedTotal = roundMoneyAmount(total);
  const remaining = roundMoneyAmount(roundedTotal - sum);
  const isValid = hasAllAmounts && Math.abs(remaining) < TOLERANCE;

  return { sum, remaining, isValid };
};

/**
 * useSplitPaymentValidation — valida que la suma de los montos ingresados
 * (uno por tarjeta) sea igual al total del pedido.
 */
export const useSplitPaymentValidation = (
  args: UseSplitPaymentValidationArgs,
): SplitPaymentValidationResult =>
  useMemo(() => computeSplitPaymentValidation(args), [args.total, JSON.stringify(args.amounts)]);
